export const TEAM_COLORS = {
    pusat: 'bg-red-100 text-red-800 border-red-200',
    umum: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    sosial: 'bg-blue-100 text-blue-800 border-blue-200',
    distribusi: 'bg-purple-100 text-purple-800 border-purple-200',
    nerwilis: 'bg-pink-100 text-pink-800 border-pink-200',
    produksi: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    ipds: 'bg-cyan-100 text-cyan-800 border-cyan-200',
    garda: 'bg-teal-100 text-teal-800 border-teal-200',
    zi: 'bg-rose-100 text-rose-800 border-rose-200',
    ukk: 'bg-olive-100 text-olive-800 border-olive-200',
    humas: 'bg-amber-100 text-amber-800 border-amber-200',
    pss: 'bg-lime-100 text-lime-800 border-lime-200',
    sakip: 'bg-sky-100 text-sky-800 border-sky-200',
    descan: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    pojok: 'bg-violet-100 text-violet-800 border-violet-200',
    pekppp: 'bg-stone-100 text-stone-800 border-stone-200',
    iso: 'bg-zinc-100 text-zinc-800 border-zinc-200',
    kualitas_resiko: 'bg-green-100 text-green-800 border-green-200',
    sensus_2026: 'bg-orange-100 text-orange-800 border-orange-200',
    epss: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200',
    eksternal: 'bg-taupe-100 text-taupe-800 border-taupe-200',
    default: 'bg-gray-100 text-gray-800 border-gray-200'
};

export const FULL_DAY_TEAMS = ['kepala', 'ukk'];

export const AGENDA_TEAMS = {
    pusat: 'BPS RI',
    eksternal: 'Eksternal',
    umum: 'Bagian Umum',
    sosial: 'Tim Statistik Sosial',
    distribusi: 'Tim Statistik Distribusi',
    nerwilis: 'Tim Statistik Nerwilis',
    produksi: 'Tim Statistik Produksi',
    ipds: 'Tim IPDS',
    garda: 'Tim Garda SE2026',
    zi: 'Tim ZI/CC',
    ukk: 'Tim Inovasi dan Unit Kerja Kepala',
    humas: 'Tim Humas',
    pss: 'Tim Pembinaan Statistik Sektoral',
    sakip: 'Tim SAKIP',
    descan: 'Tim Desa Cantik',
    pojok: 'Tim Pojok Statistik',
    pekppp: 'Tim PEKPPP',
    iso: 'Tim ISO 9001:2015',
    kualitas_resiko: 'Tim Kualitas Data dan Manajemen Resiko',
    sensus_2026: 'Tim Sensus Ekonomi 2026',
    epss: 'Tim EPSS',
};

const { pusat, ...OTHER_AGENDA_TEAMS } = AGENDA_TEAMS;

export const ATTENDING_TEAMS = {
    kepala: 'Kepala BPS Provinsi Kalimantan Utara',
    all_asn: 'Semua Pegawai ASN BPS Prov. Kaltara',
    all_pegawai: 'Semua Pegawai BPS Prov. Kaltara',
    prov_kako: 'BPS Prov dan Kako',
    internal_eksternal: 'Internal dan Eksternal',
    ...OTHER_AGENDA_TEAMS
};
